export default __webpack_public_path__ + "static/nikki-leone-og-ff62b061da5c78e2f1c452311435dc18.jpg";